export function formatDateWithoutSeconds(inputDate, withTimezone) {
    let date = new Date(inputDate);   
    let day = withTimezone ? date.getDate() : date.getUTCDate()
    let hours = withTimezone ? date.getHours() : date.getUTCHours()
    let minutes = withTimezone ? date.getMinutes() : date.getUTCMinutes()

    day = day.toString().padStart(2,'0')
    hours = hours.toString().padStart(2,'0')
    minutes = minutes.toString().padStart(2,'0')
    return `${day} ${date.toLocaleString('en-EU', { month: 'short' })} ${date.getFullYear()}, ${hours}:${minutes}`;
}